'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Box } from '@design-system/box';
import { HtmlContent, HtmlContentWithIframe } from './HtmlContent';
import { listStyles } from './htmlStyle';
export const sharedStyles = () => css `
  font-size: 1.1rem;
  line-height: 1.7rem;

  a img {
    vertical-align: middle;
  }

  img {
    height: auto;
    display: inline-block;
  }

  & * {
    font-size: inherit;
    line-height: inherit;
  }

  a {
    font-weight: normal;

    &:hover {
      font-weight: normal;
    }
  }

  // clearfix
  &:after {
    content: '';
    clear: both;
    display: table;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0.5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.25rem;
  }

  h6 {
    font-size: 1rem;
  }

  blockquote {
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;

    padding: 6px 8px 6px 20px;
    border-left: 5px solid #ccc;

    p {
      margin: 0;

      &:not(:last-of-type) {
        margin-bottom: 12px;
      }
    }
  }

  ${listStyles()}

  div,
  p,
  iframe {
    max-width: 100%;
  }

  table {
    td,
    th {
      padding: 5px;
    }
  }
`;
const Wrapper = styled(Box).attrs({
    display: 'block',
    width: '100%',
}) `
  ${sharedStyles}
`;
export const PublicationText = ({ content, withIframes = true, }) => (_jsx(Wrapper, { children: withIframes ? (_jsx(HtmlContentWithIframe, { content: content, stylesConfig: "web" })) : (_jsx(HtmlContent, { content: content, stylesConfig: "web" })) }));
//# sourceMappingURL=PublicationText.js.map